// extracted by mini-css-extract-plugin
export default {"DataField":"_DataField--HVUOu","Description":"_Description--M80XX","Label":"_Label--HMwYD"};